import { DownOutlined } from '@ant-design/icons'
import { Dropdown, LinkButton, MenuProps, UserAvatar } from 'admin-web-ui'
import { AuthGroups, isAuthorized } from 'admin-web-utils'
import { compact } from 'lodash'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { CustomerGroup } from '../../auth'
import { useConsoleContext } from '../../containers/Console'
import { LogoutButton } from '../LogoutButton'

const StyledLinkButton = styled(LinkButton)`
  display: inline-flex;
  align-items: center;
`

const StyledDownOutlined = styled(DownOutlined)`
  margin-left: 5px;
`

const StyledAvatar = styled(UserAvatar)`
  display: inline-flex;
`

function createOverlay(authGroups: AuthGroups): MenuProps['items'] {
  const menuItems = compact([
    {
      key: 'profile',
      label: <Link to="/console/profile">User Profile</Link>,
    },
    isAuthorized(CustomerGroup.AccessAdmin, authGroups) && {
      key: 'account-users',
      label: <Link to="/console/account-users">Manage Account Users</Link>,
    },
    {
      key: 'logout',
      label: <LogoutButton />,
    },
  ])

  return menuItems
}

export const UserDropDown: React.FC = () => {
  const { me } = useConsoleContext()

  const items = useMemo(() => {
    return createOverlay(me.authGroups)
  }, [me])

  return (
    <Dropdown
      className="automation-UserDropDown"
      menu={{ items }}
      trigger={['click']}
    >
      <StyledLinkButton>
        <StyledAvatar userInfo={me} type="primary" />
        <StyledDownOutlined />
      </StyledLinkButton>
    </Dropdown>
  )
}
